import { createFileRoute } from "@tanstack/react-router";

import { LocationDetailPage } from "../../../../features/locations/location-detail-page";

export const Route = createFileRoute("/_app/settings/locations/$id")({ component: LocationRoute });

function LocationRoute() {
  const { id } = Route.useParams();
  return <LocationDetailPage id={id} />;
}
